import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';

const AddEditBanks = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            id: '',
            name: '',
            status: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

            setLoadingBtn(true);
            const addData = {
                name: data.name,
                createdBy: user?.data?.userId
            };

            const editData = {
                id: data.id,
                name: data.name,
                status: data.status,
                modifiedBy: user?.data?.userId
            };

            // if (!editable) {
            //     const response = await dispatch(handlePostRequest(addData, endPoints.addUser, true));
            //     if (response?.status === 200) {
            //         formik.resetForm();
            //         onHide();
            //     }
            //     setLoadingBtn(false);
            // } else {
            //     const response = await dispatch(handlePutRequest(editData, endPoints.updateUser, true));
            //     if (response?.status === 200) {
            //         formik.resetForm();
            //         onHide();
            //     }
            //     setLoadingBtn(false);
            // }
        }
    });

    const getBankById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getBankById(rowRecord.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('name', response?.data?.name);
            formik.setFieldValue('status', response?.data?.status);
        }
        setLoadingBtn(false);
    };

    // useEffect(() => {
    //     if (editable || viewable) {
    //         getBankById();
    //     }
    // }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Bank Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default AddEditBanks;
